import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Disputed stock waiting for logistics to rule on it.

export function useStockDisputes() {
  return useQuery({
    queryKey: ['stock-disputes'],
    queryFn: async () => (await api.get('/api/stock-borrows/disputes')).data,
    // this is a work queue — a stale one means two people rule on the same thing
    staleTime: 0,
    retry: false,
  });
}

export function useFleetVans() {
  return useQuery({
    queryKey: ['stock-disputes', 'vans'],
    queryFn: async () => (await api.get('/api/stock-borrows/vans')).data.vans,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useResolveDispute(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) => (await api.post(`/api/stock-borrows/${id}/resolve`, body)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stock-disputes'] }),
  });
}
